import { z } from 'zod';

/**
 * Shape of a single file's processing plan submitted to /submit-batch.
 * This is what the frontend sends per file in the `files` array.
 */
export const SynthesisFileInputSchema = z.object({
  documentID: z.string().uuid(),
  dossierID: z.string().uuid(),
  dossierName: z.string().min(1),
  clientName: z.string().nullable().optional(),
  lawyerName: z.string().nullable().optional(),
  typeDeProcedure: z.string().nullable().optional(),
  documentCategory: z.string().nullable().optional(),
  documentSubcategory: z.string().nullable().optional(),
  // `case_documents.piece_number` is VARCHAR(50): values such as "2bis" and
  // "Annexe A" are legitimate legal references. Keep numeric input accepted
  // during the rollout so Redis jobs created by older clients remain resumable.
  pieceNumber: z.union([
    z.string().trim().min(1).max(50),
    z.number().int().nonnegative(),
  ]).nullable().optional(),
  pieceDescription: z.string().nullable().optional(),
  enableVectorization: z.boolean().default(false),
  vectorizeOriginal: z.boolean().default(false),
  vectorizeSynthesis: z.boolean().default(false),
  chunkSize: z.number().int().positive().default(1000),
  NoTitreModifications: z.boolean().default(false),
  // Set exclusively by the server-side submission service after it has checked
  // the durable status and OCR markdown. Legacy/browser payloads keep the full
  // pipeline default and cannot request a partial processing plan themselves.
  retryScope: z.enum(['full_pipeline', 'enrichment_only']).default('full_pipeline'),
});

export type SynthesisFileInput = z.infer<typeof SynthesisFileInputSchema>;
